/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_EnabledInputs */



/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Team_Manager_EnabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_enabled = /** @type {((inputs?: Team_Manager_EnabledInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_EnabledInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ermöglicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilitato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已启用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("有効")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रिय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Habilitado")
	return /** @type {LocalizedString} */ ("Enabled")
});